import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { adminAPI } from '../../services/api';
import toast from 'react-hot-toast';

export const fetchAdminDashboard = createAsyncThunk('admin/fetchDashboard', async (_, { rejectWithValue }) => {
  try {
    const response = await adminAPI.getDashboard();
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch dashboard');
  }
});

export const updateTrainerPayment = createAsyncThunk('admin/updateTrainerPayment', async ({ id, status }, { rejectWithValue }) => {
  try {
    const response = await adminAPI.updateTrainerPayment(id, status);
    toast.success('Payment status updated!');
    return response.data.trainer;
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update payment status';
    toast.error(message);
    return rejectWithValue(message);
  }
});

const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    dashboard: null,
    trainers: [],
    members: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminDashboard.fulfilled, (state, action) => { state.dashboard = action.payload; })
      .addCase(updateTrainerPayment.fulfilled, (state, action) => {
        const index = state.trainers.findIndex(t => t.id === action.payload.id);
        if (index !== -1) state.trainers[index] = action.payload;
      });
  },
});

export const { clearError } = adminSlice.actions;
export const selectAdminDashboard = (state) => state.admin.dashboard;
export default adminSlice.reducer;
